import { useFieldArray } from 'react-final-form-arrays';

import { FWorkflowStepDefinitionFragment } from '@dashboard/generated/wp/platform';

export default function useStepDefinitionsMutator() {
  return useFieldArray<FWorkflowStepDefinitionFragment>('stepDefinitions');
}
